module.exports = __webpack_public_path__ + "img/93962.f7569a39.svg";